import type { EagColumn } from '../types/EagColumn';
import type { EagGridTableProps } from '../types/EagGridTableProps';
import { isEagColumnGroup } from './isEagColumnGroup';

/**
 * Flattens a column config (which may contain column groups) into a flat list of EagColumn.
 * Groups are expanded and only their children are included; groups themselves are not emitted.
 */
export function flattenColumnConfig(columnConfig: EagGridTableProps['columnConfig']): EagColumn[] {
  const result: EagColumn[] = [];
  for (const item of columnConfig) {
    if (isEagColumnGroup(item)) {
      for (const child of item.children) {
        result.push(child);
      }
    } else {
      result.push(item);
    }
  }
  return result;
}